import {
  onShowModalSolcitudesDemanda,
  onShowModalSolicitudAmnistia,
  onShowSolicitudAmnistia,
  onChangeComponent,
  onResetHome,
} from "store";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import { useUiStore } from "./useUiStore";

export const useHomeStore = () => {
  const {
    showSolicitudAmnistia,
    showModalNuevoPromocion,
    showSolicitudesDemanda,
    component,
  } = useAppSelector((state) => state.home);
  const { resetPaginador } = useUiStore();

  const dispatch = useAppDispatch();
  const showModalSolicitud = () => dispatch(onShowSolicitudAmnistia());
  const showModalPromocionPenal = () =>
    dispatch(onShowModalSolicitudAmnistia());
  const showModalDemandasEnLinea = () =>
    dispatch(onShowModalSolcitudesDemanda());
  const changeComponent = (component: number) => {
    dispatch(onChangeComponent(component));
  };
  const changeHomeInitial = () => {
    changeComponent(1);
    resetPaginador();
  };
  const resetStateHome = () => dispatch(onResetHome())

  return {
    /**Propiedades **/
    component,
    showSolicitudAmnistia,
    showModalNuevoPromocion,
    showSolicitudesDemanda,
    /** Métodos **/
    changeComponent,
    changeHomeInitial,
    showModalSolicitud,
    showModalPromocionPenal,
    showModalDemandasEnLinea,
    resetStateHome
  };
};
